import React, { FC, useContext, useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../store';
import { IRoundGame } from '../../../../store/admin/eventRounds/store';

import DialogActions from './Components/DialogActions/DialogActions';
import PlayerInfo from './Components/PlayerInfo/PlayerInfo';
import { PlayerEditorModalStyled } from './PlayerEditorModal.Styles';
import { PlayerNotes } from './Components/PlayerMetaData/Components/PlayerNotes/PlayerNotes';
import { SelectIndex } from './Components/PlayerMetaData/Components/SelectIndex/SelectIndex';
import Tees from './Components/PlayerMetaData/Components/Tees';
import { PlayerMetaDataStyled } from './Components/PlayerMetaData/PlayerMetaData.Styles';
import Flight from './Components/PlayerMetaData/Components/Flight';
import { useAdminRound } from '../../../../contrib/Hooks/useAdminRound.hook';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import { getEnrollmentGame } from '../../../../components/Utils/getEnrollmentGame';

export const PlayerEditorModal: FC = () => {
  const {
    actions: {
      playerEditorModal: { closeModal }
    },
    playerEditorModal: { modalIsOpen, enrollment }
  } = useContext(GlobalContext);

  const { roundId } = useRouteInfoState();
  const [round] = useAdminRound(roundId);

  const [playerGame, setPlayerGame] = useState<IRoundGame>();

  useEffect(() => {
    if (round && enrollment) {
      const gameFound = getEnrollmentGame(round, enrollment.id);

      if (gameFound) {
        setPlayerGame(gameFound);
      }
    }
  }, [round, enrollment]);

  return (
    <PlayerEditorModalStyled
      fullWidth={true}
      maxWidth="lg"
      onClose={closeModal}
      aria-labelledby="customized-dialog-title"
      open={modalIsOpen}
    >
      <DialogActions />

      <PlayerInfo game={playerGame} />

      <PlayerMetaDataStyled>
        <Grid className="grid" container={true} spacing={4}>
          <Grid className="grid-item" item={true} xs={12} sm={6} md={3}>
            <SelectIndex game={playerGame} />
          </Grid>

          <Grid className="grid-item" item={true} xs={12} sm={6} md={3}>
            <Tees game={playerGame} />
          </Grid>

          <Grid className="grid-item" item={true} xs={12} sm={6} md={3}>
            <Flight game={playerGame} />
          </Grid>

          <Grid className="grid-item" item={true} xs={12} sm={6} md={3}>
            <PlayerNotes />
          </Grid>

          {!playerGame && (
            <Grid className="grid-item no-tee" item={true} xs={12}>
              <p>
                Players will be assigned an index, tee and flight based on the event and round
                settings.
              </p>
              <p>
                Once the player is placed in the tee sheet each of the items above can be modified.
              </p>
            </Grid>
          )}
        </Grid>
      </PlayerMetaDataStyled>
    </PlayerEditorModalStyled>
  );
};
